import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "TrainingFeedback" })
export default class TrainingFeedback extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isStarted: boolean = false;
    public isFeedbackEnable: boolean = false;
    public isExist: boolean = true;
    public validationErrors: any[] = [];

    public formData: any = { feedbackData: [] };
    public questions: any[] = [];
    public formDataAnswers: string[] = [];
    public questionindex: number = 0;
    public styleProgessBar: number = 10;

    @Prop() readonly trainingType: string;
    @Prop() readonly trainingCourseIdMaster: string;

    @Watch("isTrainingFeedbackVisible") onTrainingFeedbackVisibleChanged(newValue: boolean) {
        if (newValue && this.isFeedbackEnable && this.isExist) {
            this.startTest();
        }
    }

    get isTrainingFeedbackVisible() {
        return this.$store.getters["myTrainingStore/isTrainingFeedbackVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        const result = (await Axios.post(this.routes.MyBremboPartsTraining_CheckTrainingFeedbackExists, { trainingCourseIdMaster: this.trainingCourseIdMaster })).data;

        this.isFeedbackEnable = result.isFeedbackEnable;
        this.isExist = result.isExist;
        this.questions = result?.feedbackQuestionsData?.filter(x => x.trainingType === this.trainingType);
    }

    public async startNow() {
        this.isStarted = true;
    }

    public setAnswer(index: number) {
        this.validationErrors = [];

        switch (this.questions[index].type) {
            case "Single":
                if (this.formDataAnswers.length === 0) {
                    this.validationErrors = FormHelper.getValidationErrors({ Answer: [this.localizer.get("App.MyBremboParts.TrainingFeedback_AnswerRequired")] });
                    return;
                }

                this.formData.feedbackData.push({ questionName: this.questions[index].name, answerName: this.formDataAnswers });
                break;
            case "OpenAnswer":
                if (this.formDataAnswers.length > 250) {
                    this.validationErrors = FormHelper.getValidationErrors({ Answer: [this.localizer.get("App.MyBremboParts.TrainingFeedback_AnswerNotValid")] });
                    return;
                }

                this.formData.feedbackData.push({ questionName: this.questions[index].name, answerName: this.formDataAnswers.length !== 0 ? this.formDataAnswers : null });
                break;
        }

        if ((this.questionindex + 1) === this.questions.length) {
            this.submitForm();
            return;
        }

        this.formDataAnswers = [];
        this.questionindex += 1;

        this.setProgessBar();
    }

    public setProgessBar() {
        this.styleProgessBar = (((this.questionindex + 1) / this.questions.length) * 70) + 30;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        this.formData.trainingCourseIdMaster = this.trainingCourseIdMaster;
        this.formData.trainingType = this.trainingType;

        try {
            await Axios.post(this.routes.MyBremboPartsTraining_SaveTrainingFeedback, this.formData);

            this.isSuccess = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public startTest() {
        this.$store.commit("myTrainingStore/setTrainingTestVisible", true);
        this.$store.commit("myTrainingStore/setTrainingFeedbackVisible", false);
    }
}